module.exports = {"type":"rect","from":{"data":"breakdown"},"encode":{"enter":{},"update":{"x":{"field":"x"},"y":{"field":"y"},"fill":{"field":"color"},"stroke":{"value":"#4374A0"},"strokeWidth":{"value":0.7},"opacity":{"field":"opacity"},"width":{"field":"width"},"height":{"field":"height"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/marks/tree/summary-nodes/symbol-group/symbol.json
// module id = ngIM
// module chunks = 0